module.exports = __webpack_public_path__ + "img/product-selected-01.5804efa3.png";